import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import {
  Route,
  Redirect,
  Switch,
} from '@folio/stripes/core';

import Settings from './settings';
import {
  TaskListRoute,
  TaskCreateRoute,
  TaskEditRoute,
  TaskViewRoute,
  JobTemplateCreateRoute,
  JobTemplateEditRoute,
  JobTemplateListRoute,
  JobTemplateViewRoute,
  JobListRoute,
  JobCreateRoute,
  JobEditRoute,
  JobViewRoute,
  RootLayer,
} from './routes';

class TaskList extends React.Component {
  static propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
    match: ReactRouterPropTypes.match.isRequired,
    stripes: PropTypes.shape({
      connect: PropTypes.func.isRequired,
    }).isRequired,
    showSettings: PropTypes.bool,
  };

  render() {
    const {
      showSettings,
      match: {
        path: rootPath
      }
    } = this.props;

    if (showSettings) {
      return <Settings {...this.props} />;
    }

    return (
      <Route
        component={RootLayer}
        path={`${rootPath}`}
      >
        <Switch>
          <Route
            exact
            component={TaskCreateRoute}
            path={`${rootPath}/tasks/create`}
          />
          <Route
            exact
            component={TaskEditRoute}
            path={`${rootPath}/tasks/:id/edit`}
          />
          <Route
            component={TaskListRoute}
            path={`${rootPath}/tasks`}
          >
            <Route
              exact
              component={TaskViewRoute}
              path={`${rootPath}/tasks/:id/view`}
            />
          </Route>
          <Route
            exact
            component={JobTemplateCreateRoute}
            path={`${rootPath}/job-templates/create`}
          />
          <Route
            exact
            component={JobTemplateEditRoute}
            path={`${rootPath}/job-templates/:id/edit`}
          />
          <Route
            component={JobTemplateListRoute}
            path={`${rootPath}/job-templates`}
          >
            <Route
              exact
              component={JobTemplateViewRoute}
              path={`${rootPath}/job-templates/:id/view`}
            />
          </Route>
          <Route
            exact
            component={JobCreateRoute}
            path={`${rootPath}/jobs/create/job-templates/:id`}
          />
          <Route
            exact
            component={JobEditRoute}
            path={`${rootPath}/jobs/:id/edit`}
          />
          <Route
            component={JobListRoute}
            path={`${rootPath}/jobs`}
          >
            <Route
              exact
              component={JobViewRoute}
              path={`${rootPath}/jobs/:id/view`}
            />
          </Route>
          <Redirect to={`${rootPath}/tasks`} />
        </Switch>
      </Route>
    );
  }
}

export default TaskList;
